module.exports = __webpack_public_path__ + "static/media/VS.b1b39852.svg";